import { createElement, useMemo } from 'react';
import { messageMarkdown, messageMarkdownStyles, type MessageNode } from '@24talk/shared/markdown';
import type { Citation } from '@24talk/shared';

function renderNode(node: MessageNode, key: number): React.ReactNode {
  if (typeof node === 'string') return node;
  return createElement(
    node.tag,
    {
      key,
      ...(node.tag === 'a'
        ? { href: node.href, target: '_blank', rel: 'noopener noreferrer' }
        : {}),
      ...(node.tag === 'ol' ? { start: node.start } : {}),
    },
    ...node.children.map(renderNode),
  );
}

export function MessageMarkdown({
  text,
  citations,
}: {
  text: string;
  citations?: Citation[] | null | undefined;
}) {
  const nodes = useMemo(() => messageMarkdown(text, citations), [text, citations]);
  return (
    <div className="message-markdown">
      <style>{messageMarkdownStyles}</style>
      {nodes.map(renderNode)}
    </div>
  );
}
